import {
  setFloor,
  setIntercom,
  setApartement,
  setEntranceway,
  useAppDispatch,
  setAnotherFloor,
  setAnotherIntercom,
  setAnotherApartement,
  changeLeaveAtTheDoor,
  setAnotherEntranceway,
  changeAnotherLeaveAtTheDoor,
} from '@/app/store';
import { useCallback } from 'react';

export const useDeliveryChangePersonalInfo = (isOrderAnotherPerson?: boolean) => {
  const dispatch = useAppDispatch();

  const onSetEntranceway = useCallback(
    (entranceway: string) => {
      if (isOrderAnotherPerson) dispatch(setAnotherEntranceway(entranceway));
      else dispatch(setEntranceway(entranceway));
    },
    [dispatch, isOrderAnotherPerson],
  );

  const onSetFloor = useCallback(
    (floor: string) => {
      if (isOrderAnotherPerson) dispatch(setAnotherFloor(floor));
      else dispatch(setFloor(floor));
    },
    [dispatch, isOrderAnotherPerson],
  );

  const onSetApartement = useCallback(
    (apartment: string) => {
      if (isOrderAnotherPerson) dispatch(setAnotherApartement(apartment));
      else dispatch(setApartement(apartment));
    },
    [dispatch, isOrderAnotherPerson],
  );

  const onSetIntercom = useCallback(
    (intercom: string) => {
      if (isOrderAnotherPerson) dispatch(setAnotherIntercom(intercom));
      else dispatch(setIntercom(intercom));
    },
    [dispatch, isOrderAnotherPerson],
  );

  const onChangeLeaveAtTheDoor = useCallback(
    (leaveAtTheDoor: boolean) => {
      if (isOrderAnotherPerson) dispatch(changeAnotherLeaveAtTheDoor(leaveAtTheDoor));
      else dispatch(changeLeaveAtTheDoor(leaveAtTheDoor));
    },
    [dispatch, isOrderAnotherPerson],
  );

  return {
    onSetFloor,
    onSetIntercom,
    onSetApartement,
    onSetEntranceway,
    onChangeLeaveAtTheDoor,
  };
};
